import { z } from 'zod';
import { unFormatCurrency, unFormatUnknownUnit } from "@/common/utils/unFormatters";

export const productSchema = z.object({
  product_id: z.string(),
  quantity: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
  unitary_amount: z.string({ message: 'Campo obrigatório' }).refine(unFormatCurrency, {
    message: 'Campo obrigatório',
  }),
  amount: z.string(),
  display_name: z.string().optional(),
});

export const createSchema = z.object({
  card_identifier: z.string({ message: 'Campo obrigatório' }).optional(),
  card_id: z.string({ message: 'Equipamento não encontrado' }),
  card_type: z.string().optional(),
  establishment_branch_id: z.object({
    label: z.string(),
    value: z.string()
  }, { message: 'Campo obrigatório' }),
  buyer_id: z.object({
    label: z.string(),
    value: z.string()
  }, { message: 'Campo obrigatório' }),
  total_quantity: z.number(),
  total_amount: z.number(),
  current_equipment_usage: z.string().optional(),
  line_items_attributes: z.array(productSchema).min(1, { message: 'Deve haver pelo menos um produto' }),
  category_bypass_consumption_usage_validations: z.boolean().optional().nullable(),
}).superRefine((data, ctx) => {
  if (data.card_type === 'Client::Card::Fleet' && !data.category_bypass_consumption_usage_validations && (!data.current_equipment_usage || !unFormatUnknownUnit(data.current_equipment_usage))) {
    ctx.addIssue({
      path: ['current_equipment_usage'],
      code: z.ZodIssueCode.custom,
      message: 'Campo obrigatório',
    })
  }
});

export type ConsumptionValidationSchema = z.infer<typeof createSchema>;
